import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatWIT } from "@/lib/appApi";
import { StatusBadge, STATUS_LABELS } from "@/lib/adminConst";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

const GROUPS = [
  { key: "pending_review", label: "Menunggu Pemeriksaan" },
  { key: "verified", label: "Terverifikasi" },
  { key: "approved", label: "Siap Terbit" },
  { key: "needs_revision", label: "Perlu Revisi" },
];

export default function ReviewQueue() {
  const [all, setAll] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get("/articles").then((r) => setAll(r.data)).finally(() => setLoading(false)); }, []);

  const byStatus = (s) => all.filter((a) => a.status === s);

  return (
    <div>
      <h1 className="font-serif text-3xl font-extrabold text-dlh-green mb-6">Antrean Pemeriksaan & Revisi</h1>
      {loading ? <p className="text-gray-500">Memuat…</p> : (
        <Tabs defaultValue="pending_review">
          <TabsList className="mb-4 flex-wrap h-auto">
            {GROUPS.map((g) => <TabsTrigger key={g.key} value={g.key} data-testid={`queue-tab-${g.key}`}>{g.label} ({byStatus(g.key).length})</TabsTrigger>)}
          </TabsList>
          {GROUPS.map((g) => (
            <TabsContent key={g.key} value={g.key}>
              {byStatus(g.key).length === 0 ? (
                <div className="bg-white rounded-xl border border-dashed border-gray-300 p-10 text-center text-gray-400">Tidak ada artikel pada status {STATUS_LABELS[g.key]}.</div>
              ) : (
                <div className="space-y-3">
                  {byStatus(g.key).map((a) => (
                    <Link key={a.id} to={`/admin/konten/${a.id}`} data-testid={`queue-item-${a.id}`}
                      className="flex items-center justify-between gap-4 bg-white rounded-xl border border-gray-200 p-4 hover:shadow-md transition-shadow">
                      <div className="min-w-0">
                        <p className="font-semibold text-dlh-green truncate">{a.title}</p>
                        <p className="text-xs text-gray-500 mt-1">Oleh {a.created_by_name || "—"} · Diperbarui {formatWIT(a.updated_at)}</p>
                        {a.correction_note && g.key === "needs_revision" && <p className="text-xs text-amber-600 mt-1">Catatan: {a.correction_note}</p>}
                      </div>
                      <StatusBadge status={a.status} />
                    </Link>
                  ))}
                </div>
              )}
            </TabsContent>
          ))}
        </Tabs>
      )}
    </div>
  );
}
